<template>
    <div>
        <div class="fixed-div">
            <div class="search-div-parent">
                <div class="search-div">
                    <img class="search-img" src="../assets/flights/o_icon_search_32px_@2x.m.png" />
                    <input class="search-input" placeholder="请输入城市/机场" v-model="searchInputValue"/>
                </div>
                <div class="cancel-btn" @click="cancel">取消</div>
            </div>
            <div v-show="searchInputValue!==''">
                <div class="city-item" v-for="(item,index) in searchResult" :key="index" @click="selectCity(item.areaShortName,item.iataCode)">
                    {{item.areaShortName}}
                </div>
            </div>
            <div v-show="searchInputValue===''" style="height:calc( 100vh - 2rem );width:100vw;">
                <jlkj-index-bar @changeCityBySon="selectCity" :dataJson="mainData"></jlkj-index-bar>
            </div>
        </div>
        <jlkj-popup ref="popup" v-show="windowShow" :message="thisMessage" :type="'center'"></jlkj-popup>
    </div>
</template>
<script>
import jlkjIndexBar from './jlkj-index-bar.vue';
import JlkjPopup from './jlkj-popup.vue';
export default {
    name:"city-search-page",
    components: { jlkjIndexBar, JlkjPopup },
    props:{
        otherCity:{
            type:String
        },
        mainData:{
            type:Array
        }
    },
    data(){
        return {
            searchInputValue:'',
            // mainData:this.theMainData,
            searchResult:[],
            thisMessage:"error",
            windowShow:false,
        }
    },
    mounted(){
       // this.initPage();
    },
    watch:{
        searchInputValue(val , oldVal){
            let searchResultList=[]; 
            for(let i=1;i<this.mainData.length;i++){
                for(let j=0;j<this.mainData[i].value.length;j++){
                    let indexNum=this.mainData[i].value[j].areaShortName.indexOf(val)
                    if(indexNum!==-1){
                        searchResultList.push(this.mainData[i].value[j]);
                        searchResultList[searchResultList.length-1]['indexOf']=indexNum;
                    }
                }
            }
            searchResultList.sort(function(a,b){return a.indexOf-b.indexOf});
            this.searchResult=searchResultList;
        }
    },
    methods:{
        // initPage:function(){
            
        // },
        cancel:function(){
            this.$emit('cancel');
        },
        selectCity:function(string,code){
            if(this.otherCity===code){
                this.thisMessage="起始站与到达站不能一样";
                this.windowShow=true;
                this.$refs['popup'].readyHide(()=>{
                    this.windowShow=false;
                })
                // console.log("ahahh_error")
                return;
            }
            this.$emit('changeCity',string,code)
            this.searchInputValue='';
        }
    }
}
</script>
<style>
.fixed-div{
        position: fixed;
        left:0;
        top:0;
        z-index: 799;
        height: 100vh;
        width:100vw;
        background: #FFFFFF;
    }
    .search-div-parent{
        display: calc( 100% - 30px );
        margin:20px 15px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .search-div{
        width:calc( 100% - 3em );
        height:32px;
        background: #F7F8FA;
        border-radius: 18px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .search-div >img{
        width:23px;
        height: 23px;
        margin:0 5px 0 10px;
    }
    
    .search-div >input{
        width: calc( 100% - 38px - 20px );
        border:none;
        background: transparent;
        font-size: 13px;
    }
    .cancel-btn{
        font-size: 15px;
        font-weight: bold;
        color: #3377FF;
    }
    .city-item{
        border-bottom:1px solid #E7EBF3;
        width:calc( 100% - 60px );
        margin:0 30px;
        padding:15px 0;
        font-size: 15px;
        color: #2E3033;
    }
    .city-item:first-child{
        margin-top:-20px;
    }
    .city-item:last-child{
        border-bottom: 0;
    }
</style>